import React from 'react';
import { Typography, Row, Col, Select, Collapse } from "antd";

import moment from "moment";
import { ReactComponent as DownArrow } from "../../assets/images/icons/down_arrow.svg";
import { convertHTMLToText } from "../common";
const { Option } = Select;
const { Panel } = Collapse;

const PostageAndPayments = ({
    business_detail,
    classifiedDetail,
    exclusion,
    postage_delivery,
    postage_details,
    getFedexResponsebyCountryCode,
    posting_to,
    postingCountryList,
    renderPaymentMethods,
}) => {

    const renderPostageDelivery = (data) => {
        if (data && data.length) {
            return data.map((el, i) => {
                let temp = el.RateTypes && Array.isArray(el.RateTypes) && el.RateTypes.length ? el.RateTypes[0].split(":") : "";
                let price = temp && Array.isArray(temp) && temp.length > 1 ? temp[1] : "";
                return (
                    <tr key={i}>
                        <td>{price && `AU$${price}`}</td>
                        <td>{el.ServiceType}</td>
                        <td>Yes</td>
                        <td>
                            Estimated between{" "}
                            <strong>
                                {el.DeliveryDayOfWeek} {moment(el.DeliveryTimestamp).format("Do MMM")}
                            </strong>
                        </td>
                    </tr>
                );
            });
        }
    };

    return (
        <><Row gutter={[20, 20]}>
            <Col xs={{ span: 24 }} lg={{ span: 14 }}>
                <h4 className='tabTitle'>Postage & Payments</h4>
                <Collapse
                    expandIcon={({ isActive }) => <DownArrow className='downArrow' style={{ transform: isActive ? "rotate(180deg)  translateY(50%)" : "rotate(0deg) translateY(-50%)" }} />}
                    expandIconPosition='right'
                    bordered={false}
                    accordion
                >
                    <Panel header='Postage' key='1'>
                        <div className='postage-inner-view'>
                            <ul className='postageList'>
                                <li>
                                    <label>Item location:</label>
                                    <span className='value'>{postage_details}</span>
                                </li>
                                <li>
                                    <label>Posting to:</label>
                                    <span className='value'>{posting_to && posting_to}</span>
                                </li>
                                <li>
                                    <label>Exclusions:</label>
                                    <span className='value'>{exclusion && exclusion}</span>
                                </li>
                                {/* <li>
                                    <label>Ship to:</label>
                                    <Select style={{ width: 150 }} placeholder='Select Country' allowClear showSearch onChange={getFedexResponsebyCountryCode} optionFilterProp='children' filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}>
                                        {postingCountryList &&
                                            postingCountryList.map((el) => {
                                                return <Option value={el.isoCode}>{el.name}</Option>;
                                            })}
                                    </Select>
                                </li> */}
                            </ul>
                            <div style={{ overflowX: "auto" }}>
                                <table className='postageTable' style={{ width: "680px" }}>
                                    <tr className='heading-bg-light-grey'>
                                        <th width='180'>Postage and handling</th>
                                        <th width='100'>Carrier</th>
                                        <th width='100'>Tracking</th>
                                        <th>Delivery</th>
                                    </tr>
                                    {renderPostageDelivery(postage_delivery)}
                                    <tr>
                                        <td>AU $7.98</td>
                                        <td>DHL</td>
                                        <td>Yes</td>
                                        <td>
                                            Estimated between Wed. <strong>3 Feb - Thu. 11 Feb</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>AU $20.00</td>
                                        <td>FedEx</td>
                                        <td>Yes</td>
                                        <td>
                                            Estimated between Wed. <strong>3 Feb - Thu. 4 Feb</strong>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <small>
                                <p>* Estimated delivery dates- opens in anew window or tab include seller's handling time, origin postcode,destination postcode and time of acceptance and will depend on postageservice selected and receipt of cleared payment. Delivery times may vary,specially during peak periods.</p>
                                <p>For Delivery to Pickup station, postage options may vary.</p>
                            </small>

                            <span className='hightlight'>Domestic handling time</span>
                            <p className='notes'>Will usually post within 3 business days of receiving cleared payment.</p>
                        </div>
                    </Panel>
                    <Panel header='Return Policy' key='2' className='return-policy-container'>
                        <h3>{business_detail && business_detail.return_policy_title ? business_detail.return_policy_title : ''}</h3>
                        <p>{business_detail && business_detail.return_policy ? convertHTMLToText(business_detail.return_policy) : ''}</p>
                        <hr style={{ margin: "10px 0 20px" }} />
                        {business_detail && business_detail.return_policy_file &&
                            <p>
                                Please follow our{" "}
                                <a href={business_detail.return_policy_file} target='_blank'>
                                    Return Policy
                                </a>{" "}
                                to receive a full refund.
                            </p>
                        }
                    </Panel>
                    <Panel header='Accepted Payments' key='3' className='payment-method-container'>
                        <span className='hightlight'>Payment methods</span>
                        {business_detail && renderPaymentMethods(business_detail, false)}

                    </Panel>
                </Collapse>
            </Col>

            <Col xs={{ span: 0 }} lg={{ span: 2 }}>
                &nbsp;
            </Col>
            <Col xs={{ span: 0 }} lg={{ span: 8 }}>
                {classifiedDetail && classifiedDetail.classified_image && classifiedDetail.classified_image.length > 0 && classifiedDetail.classified_image[0].full_name ? <img src={classifiedDetail && classifiedDetail.classified_image[0].full_name && classifiedDetail.classified_image[0].full_name} alt='' style={{ width: "100%" }} /> : null}
            </Col>
        </Row>
        </>
    );
}
export default PostageAndPayments